import { PtLuxonDate } from '../projects/date.models';

export class SafetyCategory {
  id: number;
  title: string;
  definition: string;
  active: boolean;
}

export class SafetyReport {
  id: number;
  comment: string;
  safetyCategory: SafetyCategory;
}

export class SafetyCategoryReading {
  id: number;
  value: number;
  ptdValue: number;
  ytdValue: number;
  category: SafetyCategory;
}

export class SafetyWeeklySummary {
  constructor() {
    this.drills = 0;
    this.safetyMeetings = 0;
    this.toolboxTalks = 0;
    this.readingPtdSummaries = [];
    this.readingYtdSummaries = [];
  }

  id: number;
  date: PtLuxonDate;
  drills: number;
  toolboxTalks: number;
  safetyMeetings: number;
  readingPtdSummaries: SafetyCategoryReading[] = [];
  readingYtdSummaries: SafetyCategoryReading[] = [];
}

export class Safety {

  constructor() {
    this.drills = 0;
    this.toolboxTalks = 0;
    this.safetyMeetings = 0;
  }

  id: number;
  date: PtLuxonDate;
  drills: number;
  toolboxTalks: number;
  safetyMeetings: number;
  weeklyDrills: number;
  weeklyToolboxTalks: number;
  weeklySafetyMeetings: number;
  isCompleted: boolean;
  readings: SafetyCategoryReading[] = [];
  reports: SafetyReport[] = [];
}



// WEBPACK FOOTER //
// ./src/models/safety/safety.models.ts